import { OrgType } from '../../../apis/facades/types/crmOrgsApiFacade.types';

export const OrgTypeToName: Record<OrgType, string> = {
  [OrgType.Salesforce]: 'Salesforce',
  [OrgType.Snowflake]: 'Snowflake',
  [OrgType.Data360]: 'Data360',
  [OrgType.ServiceNow]: 'ServiceNow',
  [OrgType.Hubspot]: 'HubSpot',
  [OrgType.Workato]: 'Workato',
};
